import React from 'react';
import TextExtended from '../text-extended/text-extended';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { Spinner } from 'wix-ui-tpa/cssVars';
import { REPLYING_TO_BTN } from '../../../common/constants/data-hooks';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { TooltipLazy } from '../tooltip-lazy/tooltip-lazy';
import classNames from 'classnames';
import styles from './replying-to.scss';
const ReplyingTo = ({ onClick, isPending = false, targetName }) => {
    const t = useTranslate();
    const { screenshotMode } = useConfiguration();
    return (React.createElement("div", { className: styles.container },
        React.createElement(TextExtended, { className: styles.label, priority: "secondary", typography: "contentSmall" }, t('comment.replying-to')),
        React.createElement(TooltipLazy, { className: styles.tooltipContainer, minWidth: 170, appendTo: "window", content: React.createElement("div", { className: styles.tooltip }, t('comment.replying-to.tooltip')) },
            React.createElement("div", { className: styles.nameContainer },
                React.createElement("button", { className: classNames(styles.nameButton, 'wc-text-color-secondary'), "data-hook": REPLYING_TO_BTN, onClick: onClick },
                    React.createElement(TextExtended, { className: styles.name, priority: "secondary", typography: "contentSmall" }, targetName),
                    isPending && (React.createElement(Spinner, { className: styles.loader, diameter: 12, isStatic: screenshotMode })))))));
};
export default ReplyingTo;
//# sourceMappingURL=replying-to.js.map